import { objectToQueryParams } from '@akin-home/objects';
import { createQueryKeySet } from '@akin-home/utils/react-query';
import { API } from 'aws-amplify';

export const alertQueryKeys = createQueryKeySet({
  key: 'alerts',
});

export const listAllAlertsByHabitatQuery = async (
  habitatID: string,
  filters?: { from?: string; to?: string; goal_id?: string; title?: string }
) => {
  const query_params = objectToQueryParams(filters);

  return (
    await API.get(
      'CalendarAPI',
      `/alerts/habitat/${habitatID}?${query_params}`,
      {}
    )
  ).data;
};

export const getAlertQuery = async (id: string) => {
  return (await API.get('CalendarAPI', `/alerts/${id}`.replace('#', '%23'), {}))
    .data;
};
